import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
import { onMounted, onUnmounted, ref } from 'vue';
import Login from './components/Login.vue';
import DesktopHeader from './components/DesktopHeader.vue';
import MobileHeader from './components/MobileHeader.vue';
import { theme } from '../../front/Theme';
import { ThemeMediaSize } from '../../front/defs/types';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SiteHeaderApp',
    props: {
        siteHeader: {}
    },
    setup(__props, { expose: __expose }) {
        const props = __props;
        const json = props.siteHeader.json;
        const login = ref();
        const isMobile = ref(theme().mediaSize === ThemeMediaSize.MediumLarge);
        const mbh = ref();
        const dth = ref();
        onMounted(() => {
            theme().attachBreakpointListener(onBreakpointChange);
        });
        onUnmounted(() => {
            theme().removeBreakpointListener(onBreakpointChange);
        });
        function onBreakpointChange(event) {
            isMobile.value = event.detail.size <= ThemeMediaSize.MediumLarge;
        }
        __expose({
            canDuck: () => { var _a, _b; return ((_a = mbh.value) === null || _a === void 0 ? void 0 : _a.canDuck()) || ((_b = dth.value) === null || _b === void 0 ? void 0 : _b.canDuck()); },
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(Login, {
                    ref_key: "login",
                    ref: login,
                    data: _unref(json).loginData
                }, null, 8, ["data"]),
                (!isMobile.value)
                    ? (_openBlock(), _createBlock(DesktopHeader, {
                        key: 0,
                        "site-header": _ctx.siteHeader,
                        onShowLogin: _cache[0] || (_cache[0] = ($event) => { var _a; return ((_a = login.value) === null || _a === void 0 ? void 0 : _a.show()); }),
                        ref_key: "dth",
                        ref: dth
                    }, null, 8, ["site-header"]))
                    : _createCommentVNode("", true),
                (isMobile.value)
                    ? (_openBlock(), _createBlock(MobileHeader, {
                        key: 1,
                        "site-header": _ctx.siteHeader,
                        onShowLogin: _cache[1] || (_cache[1] = ($event) => { var _a; return ((_a = login.value) === null || _a === void 0 ? void 0 : _a.show()); }),
                        ref_key: "mbh",
                        ref: mbh
                    }, null, 8, ["site-header"]))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
